import MuiSvgIcon from "@material-ui/core/SvgIcon";
export { SvgIconProps, SvgIconClassKey } from "@material-ui/core/SvgIcon";
export default MuiSvgIcon;